import { getFirestore, doc, getDoc } from "firebase/firestore";
import getUserUID from "./getUserUID";

const getUserGroup = async (includeDetails = false) => {
  try {
    const db = getFirestore();
    const uid = await getUserUID();

    if (!uid) {
      throw new Error("No hay una sesión activa.");
    }

    const userDocRef = doc(db, "registeredUsers", uid);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      throw new Error("No se encontró el registro en la base de datos.");
    }

    const userData = userDoc.data();

    if (!includeDetails) {
      return userData.group || null;
    }

    return {
      group: userData.group || null,
      name: userData.name || "No disponible",
      surname: userData.surname || "No disponible",
    };
  } catch (error) {
    throw error;
  }
};

export default getUserGroup;
